/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getCustomersCardsBoxesResponse } from '../fn/customers-cards-boxes-controller/get-customers-cards-boxes-response';
import { GetCustomersCardsBoxesResponse$Params } from '../fn/customers-cards-boxes-controller/get-customers-cards-boxes-response';
import { ResponseCustomersCardsBoxesDto } from '../models/response-customers-cards-boxes-dto';

@Injectable({ providedIn: 'root' })
export class CustomersCardsBoxesControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCustomersCardsBoxesResponse()` */
  static readonly GetCustomersCardsBoxesResponsePath = '/customersCardsBoxes';

  /**
   * Select cards and Boxes of customers
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomersCardsBoxesResponse()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomersCardsBoxesResponse$Response(params?: GetCustomersCardsBoxesResponse$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseCustomersCardsBoxesDto>> {
    return getCustomersCardsBoxesResponse(this.http, this.rootUrl, params, context);
  }

  /**
   * Select cards and Boxes of customers
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomersCardsBoxesResponse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomersCardsBoxesResponse(params?: GetCustomersCardsBoxesResponse$Params, context?: HttpContext): Observable<ResponseCustomersCardsBoxesDto> {
    return this.getCustomersCardsBoxesResponse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseCustomersCardsBoxesDto>): ResponseCustomersCardsBoxesDto => r.body)
    );
  }

}
